import Dialog  from '@anm/components/modals/Dialog';
import {CloseButton, flexCenter} from '@anm/styles/helpers';
import styled from 'styled-components';

export const DialogWrapper = styled(Dialog)`
  left: 19px;
  padding: 0;
  right: 19px;
  bottom: 25px;
  position: fixed;
  max-width: 100%;
  background: none;
  ${CloseButton} {
    display: none;
  }
`;

export const ContentWrapper = styled.div`
  ${flexCenter};
  margin: auto;
  padding: 28px;
  max-width: 500px;
  background: #fff;
  border-radius: 5px;
  flex-direction: column;
`;

export const ImageContainer = styled.div`
  ${flexCenter};
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #4eda9d;
  margin-bottom: 16px;
`;

export const Message = styled.span`
  font-size: 16px;
  text-align: center;
  font-weight: normal;
  margin-bottom: 20px;
`;
